import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Clock, Zap, Sparkles } from 'lucide-react';

export function TimelineButtons() {
    return (
        <div className="flex flex-wrap gap-2">
            <Link to="/timeline">
                <Button variant="outline" size="sm" className="gap-1.5 text-xs">
                    <Clock className="w-3.5 h-3.5" />
                    Timeline
                </Button>
            </Link>
            <Link to="/timeline?tab=correlations">
                <Button variant="outline" size="sm" className="gap-1.5 text-xs">
                    <Zap className="w-3.5 h-3.5" />
                    Insights
                </Button>
            </Link>
            <Link to="/timeline?tab=patterns">
                <Button variant="outline" size="sm" className="gap-1.5 text-xs">
                    <Sparkles className="w-3.5 h-3.5" />
                    Patterns
                </Button>
            </Link>
        </div>
    );
}
